module.exports = __webpack_public_path__ + "static/media/PersonUpload_Template_V2.fb1f1ed3.xlsx";